<template>
   <ul class="m_btns">
        <li v-for="(item,index) in rightItems" :key="index" @click="routerLink(item)">
            <i :class="item.iconClass"></i>
            <span>{{item.name}}</span>
        </li>
    </ul>
</template>

<script>
    export default {
        name:"mbtns",
        data(){
            return {
                rightItems:[
                    // {name:"常见问题",iconClass:'iconfont icon-wenhao',show:false,id:'cjwt'},
                    // // {name:"Tips",iconClass:'iconfont icon-xin',show:false,id:'tips'},
                    // {name:"咨询馆员",iconClass:'iconfont icon-taolunxuanzhong',show:false,id:'zxgy'},
                ],
                isShowChangJianWenTi:false,
                isShowTips:false,
                isShowZiXunGuanYuan:false
            }
        },
        created(){
            this.isShowChangJianWenTi = this.base_url().isShowChangJianWenTi;
            this.isShowTips = this.base_url().isShowTips;
            this.isShowZiXunGuanYuan = this.base_url().isShowZiXunGuanYuan;
            if( this.isShowChangJianWenTi){
                this.rightItems.push({name:"常见问题",iconClass:'iconfont icon-wenhao',show:false,id:'cjwt'});
            }
            if(this.isShowTips){
                this.rightItems.push({name:"Tips",iconClass:'iconfont icon-xin',show:false,id:'tips'});
            }
            if(this.isShowZiXunGuanYuan){
                 this.rightItems.push({name:"咨询馆员",iconClass:'iconfont icon-taolunxuanzhong',show:false,id:'zxgy'});
            }
        },
        methods:{
            routerLink(item){
                 this.$router.push({path:'/Content',query: {id: item.id}});
            }
        }
    }
</script>

<style  scoped>
    @media screen and (min-width:768px){
        .m_btns{
            display: none;
        }
    }
    @media screen and (max-width:768px){
       .m_btns{
            position: relative;
            display: flex;
            justify-content: space-around;
            margin-top: 25px;
        }
        .m_btns li{
            height: 30px;
            line-height: 30px;
            width: 80px;
            text-align: center;
            color: #fff;
        }
        .m_btns li .iconfont{
            font-size: 12px;
        }
        .m_btns li span{
            font-size: 12px;
            font-weight: bold;
        }
        .m_btns li:nth-child(1){
            background: #fa695d;
        }
        .m_btns li:nth-child(2){
            background: #4ad5e9;
        }
        .m_btns li:nth-child(3){
            background: #00c8b0;
        }
    }
</style>